'use client'

// Кнопка озвучки для публичных страниц (словарь, фразы, лендинг): один mp3 без
// подписки и лимитов — файлы уже лежат в бакете. Один <audio> на кнопку,
// повторный клик перезапускает с начала. Без запасного голоса браузера: если
// mp3 нет, кнопка не показывается вовсе.
// Вид как у остальных кнопок озвучки (components/listen-buttons.tsx, задача 83 из
// Telegram): значок после нажатия обводится синим, подписанная пилюля синеет.
import { useRef, useState } from 'react'
import { AudioOrbIcon } from '@/components/audio-orb-icon'
import { RecordSelf } from '@/components/record-self'
import { isRecordable } from '@/lib/record-self'

export function PlayAudioButton({
  src,
  label = 'Прослушать',
  size = 22,
  compact = false,
  recordText,
}: {
  src: string | null
  label?: string
  size?: number
  // compact — только значок (в строке слова), иначе значок с подписью.
  compact?: boolean
  // Задан - рядом микрофон "Записать себя" (15.10.2026), только у коротких фраз.
  recordText?: string
}) {
  const ref = useRef<HTMLAudioElement | null>(null)
  const [playing, setPlaying] = useState(false)
  const [heard, setHeard] = useState(false)
  if (!src) return null
  function play() {
    if (!ref.current) {
      ref.current = new Audio(src!)
      ref.current.preservesPitch = true
      ref.current.onended = () => setPlaying(false)
    }
    const a = ref.current
    a.pause()
    a.currentTime = 0
    setPlaying(true)
    setHeard(true)
    a.play().catch(() => setPlaying(false))
  }
  const button = (
    <button
      type="button"
      className={compact ? 'tk-bubble-audio-btn' : 'tk-pill-toggle tk-pill-listen tk-pill-icon'}
      onClick={play}
      aria-label={label}
      title={label}
      data-playing={playing ? '' : undefined}
      data-heard={compact && heard ? '' : undefined}
      data-on={!compact && heard ? '' : undefined}
    >
      <AudioOrbIcon size={compact ? size : 36} />
      {/* С 15.10.2026 и полная кнопка только значком, подпись для экранного диктора. */}
      {!compact && <span className="sr-only">{label}</span>}
    </button>
  )
  if (!isRecordable(recordText)) return button
  return (
    // Компактные значки столбиком: в строках словаря на узком экране микрофон
    // сбоку отнимал ширину у слова, и транскрипция ломалась посреди слова.
    <span className={compact ? 'inline-flex shrink-0 flex-col items-center gap-1.5' : 'inline-flex shrink-0 items-center gap-1.5'}>
      {button}
      <RecordSelf text={recordText} audioUrl={src} compact={compact ? size : undefined} />
    </span>
  )
}
